module.exports = __webpack_public_path__ + "static/media/logoBW.e1158f4b.png";